import { hasWindow } from "@omni/utils/dom.utils";

import {
    RouterComponent,
    RouterComponentInterface
} from "@/aem/Router/router.component";
import { registerComponent } from "@/components/pureAemComponent";
import { WindowEvent } from "@/services/windowEvents/windowEvent.service";

enum HydrationState {
    Hydrated = "hydrated"
}

class Modal extends RouterComponent implements RouterComponentInterface {
    backdrop: HTMLElement | null;
    closeButton: HTMLAnchorElement | null;

    constructor(element: HTMLElement) {
        super(element);
        this.backdrop = this.element.querySelector(".js-modal-backdrop");
        this.closeButton = this.element.querySelector(".js-modal-close");
        this.init();
    }

    /**
     * Initialize the component
     */
    init() {
        this.bindEventHandlers();
    }

    /**
     * Bind the event handlers
     */
    bindEventHandlers() {
        this.backdrop?.addEventListener(
            "click",
            this.closeModalEvent.bind(this)
        );
        this.closeButton?.addEventListener(
            "click",
            this.closeModalEvent.bind(this)
        );
        hasWindow() &&
            window.addEventListener(
                WindowEvent.CloseModal,
                this.closeModalEvent.bind(this)
            );
    }

    /**
     * Show this component
     * - set the scroll lock for pages
     * - Display this modal component
     */
    activateComponent() {
        this.setScrollLock();
        this.displayModal();
        hasWindow() && window.dispatchEvent(new Event("resize"));
    }

    /**
     * Hide this component
     * - remove the scroll lock from the page
     * - Hide this modal component
     */
    deactivateComponent(unSetScroll: boolean = false) {
        if (unSetScroll) {
            this.setScrollLock(false);
        }
        this.displayModal(false);
    }

    /**
     * Show / hide this modal component
     * @param display
     */
    displayModal(display: boolean = true) {
        if (display && hasWindow()) {
            if (this.element.dataset.hydrateState !== HydrationState.Hydrated) {
                window.hydrator.rehydrateModalComponent(this.element);
                this.element.dataset.hydrateState = HydrationState.Hydrated;
            }
            this.element.classList.add(...["show", "d-block"]);
        } else {
            this.element.classList.remove(...["show", "d-block"]);
        }
    }

    /**
     * Add / remove a scroll lock class on the page
     * @param set
     */
    setScrollLock(set: boolean = true) {
        if (hasWindow() && document.body) {
            if (set) {
                document.body.classList.add("modal-open");
            } else {
                document.body.classList.remove("modal-open");
            }
        }
    }

    /**
     * Hide the component
     */
    closeModalEvent(e: Event) {
        e.preventDefault();
        this.deactivateComponent(true);
        if (this.byHash) {
            this.removeHash();
        } else {
            this.unsetQueryParam();
        }
    }
}

const InitModal = () => {
    registerComponent(".js-modal", Modal);
};

export { InitModal, Modal };
